module.exports = __webpack_public_path__ + "static/media/parking-solid.09fe67a3.svg";